import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getBumpers = createAsyncThunk("bumpers/get", async (payload) => {
  try {
    const response = await magnifiAPI.getBumpers(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteBumper = createAsyncThunk("bumpers/delete", async (payload) => {
  try {
    const response = await magnifiAPI.deleteBumper(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getBumperDetails = createAsyncThunk("bumpers/getDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getBumperDetails(payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
